// PhonicsLt01.js
// Letter Teams L01 包装组件
// 路由：/phonics/lt01
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt01 } from './phonics/phonics_data_lt01';

function PhonicsLt01() {
  return <PhonicsLt letterData={letterDataLt01} />;
}

export default PhonicsLt01;
